// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"186":"eb963c2021174592","888":"f37d511b60fa0144"}[chunkId] + ".css";
};